
function addEventListeners() {
    if (document.getElementsByClassName('toggle-parent').length) {
        var showMoreToggles = document.querySelectorAll('.toggle-control .btn');
        showMoreToggles.forEach(function (toggle) {
            var newToggle = toggle.cloneNode(true);
            newToggle.addEventListener('click', handleToggleClick);
            toggle.parentNode!.replaceChild(newToggle, toggle);
        })
    }
}

function handleToggleClick(evt: any) {
    let elem = evt.target as HTMLElement;
    if ((evt.target as any).tagName != "BUTTON") {
        elem = (evt.target as any).parentNode;
    }
    var msg = elem.firstChild;
    var closeddmsg = elem.getAttribute('data-closedmsg');
    var toggledmsg = elem.getAttribute('data-toggledmsg');
    var item = elem.parentElement?.parentElement?.querySelector('.toggle-content');

    if (item && msg && item.classList.contains('show')) {
        item.classList.remove('show');
        if (closeddmsg) {
            if (msg.nextSibling) {
                (msg.nextSibling as HTMLElement).innerHTML = closeddmsg;
            }
            else {
                (msg as HTMLElement).innerHTML = closeddmsg;
            }
        }
        elem.setAttribute('aria-expanded', 'false')
    }
    else if (item && msg) {
        item.classList.add('show');
        if (toggledmsg) {
            if (msg.nextSibling) {
                (msg.nextSibling as HTMLElement).innerHTML = toggledmsg;
            }
            else {
                (msg as HTMLElement).innerHTML = toggledmsg;
            }
        }
        elem.setAttribute('aria-expanded', 'true');
    }
}

window.onload = function () {
    addEventListeners();
}